module.exports = __webpack_public_path__ + "static/media/tearapartlogo.1dc35172.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tearapartlogo.png
// module id = 1137
// module chunks = 0